import { render, staticRenderFns } from "./planet-overview.vue?vue&type=template&id=15ae0d12&"
import script from "./planet-overview.vue?vue&type=script&lang=js&"
export * from "./planet-overview.vue?vue&type=script&lang=js&"
import style0 from "./planet-overview.vue?vue&type=style&index=0&id=15ae0d12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports